import { render, staticRenderFns } from "./IDCardASCHMA.vue?vue&type=template&id=5d3c2d04&scoped=true&"
import script from "./IDCardASCHMA.vue?vue&type=script&lang=js&"
export * from "./IDCardASCHMA.vue?vue&type=script&lang=js&"
import style0 from "./IDCardASCHMA.vue?vue&type=style&index=0&id=5d3c2d04&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d3c2d04",
  null
  
)

export default component.exports